import { cn } from '@anytag/shared-utils';
import { Icon, IconProps } from './Icon';

export const ClearIcon = ({ className, ...iconProps }: Omit<IconProps, 'icon'>) => (
  <Icon
    id="clear-indicator"
    icon="fail"
    size="16px"
    variant="light-gray"
    className={cn('mr-1 cursor-pointer hover:icon-color-gray', className)}
    {...iconProps}
  />
);
